module.exports = "/_next/static/media/121a4f6588464e8220307bd4f7f76fb2.svg";